module.exports = __webpack_public_path__ + "img/weixin.9621ac6d.png";